// @ts-check

const getPackageSize = () => {
  /** @type {HTMLInputElement|null} */
  const $packageSize = document.querySelector(
    `#main-cart-items > .js-contents [name="attributes[package_size]"]`
  );
  if (!$packageSize || $packageSize.value === "") return null;
  return $packageSize.value;
};

/**
 * チェックアウトボタンを無効にする
 * @param {HTMLButtonElement} $button
 * @param {HTMLDivElement} $error
 */
const disableCheckout = ($button, $error) => {
  $button.disabled = true;
  $error.style.display = "block";
};

/**
 * チェックアウトボタンを有効化する
 * @param {HTMLButtonElement} $button
 * @param {HTMLDivElement} $error
 */
const enableCheckout = ($button, $error) => {
  $button.disabled = false;
  $error.style.display = "none";
};

const main = () => {
  /** @type {HTMLButtonElement|null} */
  const $checkout = document.querySelector(`[name="checkout"]`);
  /** @type {HTMLDivElement|null} */
  const $error = document.querySelector(`[data-error-reached-limit-size]`);
  if (!$checkout || !$error) return;

  // 梱包サイズが上限を超えている場合はnull
  const packageSize = getPackageSize();
  // 梱包サイズが上限を超えている場合はチェックアウトボタンを無効にする
  if (packageSize === null) {
    disableCheckout($checkout, $error);
  } else {
    enableCheckout($checkout, $error);
  }
};

/** #main-cart-items のDOMが変更された時に実行する関数 */
const cartItemsMutationHandler = () => {
  main();
};

// cartItemsの変更を監視する
const observeCartItemsMutation = () => {
  /** @type {HTMLElement | null} */
  const jsContents = document.querySelector("#main-cart-items > .js-contents");
  if (!jsContents) return;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        cartItemsMutationHandler();
      }
    }
  });
  observer.observe(jsContents, { childList: true });
};

main();
observeCartItemsMutation();
